var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-features area"
  }, [_vm._m(0), _c("section", {
    staticClass: "product-features__introduction"
  }, [_c("features-card", {
    attrs: {
      featuresList: _vm.featuresList
    }
  })], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "product-features__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("ADVANTAGES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("产品优势")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };